// removed by extract-text-webpack-plugin
module.exports = {"page":"page-123zv","container":"container-35186","printArea":"printArea-9X48M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/print/_page.css
// module id = 1269
// module chunks = 1